module.exports = __webpack_public_path__ + "img/img7.7605a981.png";